module.exports = __webpack_public_path__ + "img/1535012557.561b16b0.jpg";